var path = '/pages/guestlists/views/pages/guestlists/option-links.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<al-entity-option-links\n        ng-if=\"!vm.loading\"\n        entity=\"'guestlist'\"\n        entity-id=\"vm.guestlist.id\"\n        object=\"vm.currentGuestlistObject.object\"></al-entity-option-links>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/option-links.tpl.html
// module id = 2265
// module chunks = 1